// src/App.js
import React, { Suspense, useState } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { Layout, Drawer, Button, Space, Menu,ConfigProvider  } from 'antd';
import { getmenuitems, flattenMenu } from './menuConfig';
import { routes } from './routes';
import GlobalLoading from './components/GlobalLoading';
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs';
import { zhCn }  from 'dayjs/locale/zh-cn'
import TableTooltipModal from './components/TableTooltipModal';
dayjs.locale(zhCn); 
const { Content } = Layout;
const initAuth = () => {
  try {
    const adminStr = localStorage.getItem('admin');
    if (adminStr) {
      const admin = JSON.parse(adminStr);
      if (admin && admin.token) {
        window['admuser'] = admin;
      }
    }
  } catch (e) {
    console.warn('Failed to parse admin from localStorage', e);
    localStorage.removeItem('admin'); 
  }
};

initAuth();

function detectIsMobile() {
  if (typeof window === 'undefined') return false;
  const mobileRegex = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileRegex.test(navigator.userAgent);
}
function findMenuItemByPath(pathname) {
  const flatMenuItems = flattenMenu(); 
  return flatMenuItems.find((item) => item.path === pathname) || flatMenuItems[0];
}
function DesktopSiderLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const flatMenuItems = flattenMenu(); 
  // 获取当前选中的菜单 key（支持子菜单高亮）
  const selectedKey = flatMenuItems.find(item => item.path === location.pathname)?.key || 'home';

  const menuItems = getmenuitems();
  // 转换 menuItems 为 Menu.items 格式
  const transformMenu = (items) => {
    return items.map(item => {
      const base = {
        key: item.key,
        label: item.label,
        icon: item.icon,
      };
  
      if (item.path) {
        base.onClick = () => navigate(item.path);
      }
  
      if (item.children && item.children.length > 0) {
        base.children = transformMenu(item.children);
      }
  
      return base;
    });
  };
  
  // 使用
  const menuData = transformMenu(menuItems); // 改成 transformMenu
  // const menuData = menuItems.map(item => {
  //   if (item.children) {
  //     return {
  //       key: item.key,
  //       label: item.label,
  //       icon: item.icon,
  //       children: item.children.map(child => ({
  //         key: child.key,
  //         label: child.label,
  //         onClick: () => navigate(child.path),
  //       })),
  //     };
  //   } else {
  //     return {
  //       key: item.key,
  //       label: item.label,
  //       icon: item.icon,
  //       onClick: () => navigate(item.path),
  //     };
  //   }
  // });

  return (
    <Layout style={{ height: 'calc(100vh - 16px)', overflowY:'auto', overflow:'hidden' }}>
      <Layout.Sider width={260} theme="light">
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuData}
          style={{ height: '100%', borderRight: 0, overflow: 'hidden', overflowY: 'auto' }}
        />
      </Layout.Sider>
      <Layout>
        <Content style={{ padding: 24, paddingBottom:0 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
function ResponsiveLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = detectIsMobile();
  const currentItem = findMenuItemByPath(location.pathname);

  const goTo = (path) => {
    navigate(path);
  };

  if (isMobile) {
    return <MobileNavLayout currentItem={currentItem} onNavigate={goTo} />;
  }
  return <DesktopSiderLayout currentItem={currentItem} onNavigate={goTo} />;
}

function MobileNavLayout({ currentItem, onNavigate }) {
  const flatMenuItems = flattenMenu();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const visibleCount = 3;
  const visibleItems = flatMenuItems.slice(0, visibleCount);
  const hiddenItems = flatMenuItems.slice(visibleCount);

  return (
    <>
      <div style={{ paddingBottom: 60 }}>
        <Outlet />
      </div>

      <div
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          background: '#fff',
          borderTop: '1px solid #eee',
          display: 'flex',
          justifyContent: 'space-around',
          padding: '8px 0',
          zIndex: 1000,
        }}
      >
        {visibleItems.map((item) => (
          <Button
            key={item.key}
            type={currentItem.key === item.key ? 'primary' : 'text'}
            shape="circle"
            icon={item.icon}
            onClick={() => onNavigate(item.path)}
          />
        ))}
        {hiddenItems.length > 0 && (
          <Button
            shape="circle"
            type={hiddenItems.some((h) => h.key === currentItem.key) ? 'primary' : 'default'}
            onClick={() => setDrawerOpen(true)}
          >
            ⋯
          </Button>
        )}
      </div>

      <Drawer
        title="更多"
        placement="bottom"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        height="40%"
      >
        <Space direction="垂vertical" size="middle" style={{ width: '100%' }}>
          {hiddenItems.map((item) => (
            <Button
              key={item.key}
              block
              icon={item.icon}
              type={currentItem.key === item.key ? 'primary' : 'default'}
              onClick={() => {
                onNavigate(item.path);
                setDrawerOpen(false);
              }}
            >
              {item.label}
            </Button>
          ))}
        </Space>
      </Drawer>
    </>
  );
}

// 主 App
export default function App() {
  return (
    <ConfigProvider locale={zhCN}>
    <BrowserRouter>
      <Suspense fallback={<GlobalLoading />}>
        <TableTooltipModal />
        <Routes>
          <Route element={<ResponsiveLayout />}>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
    </ConfigProvider>
  );
}